"use client"

import type { ReactNode } from "react"

export interface PageShellProps {
  title?: string
  description?: string
  children: ReactNode
  className?: string
  actions?: ReactNode
}

/**
 * Standard page content shell: title, optional description, and content.
 * Matches the design language of the account page (AccountPageShell).
 */
export function PageShell({ title, description, children, className, actions }: PageShellProps) {
  const base = "flex-1 space-y-8 p-6 pb-[var(--footer-height,2.8125rem)]"
  return (
    <div className={className ? `${base} ${className}` : base}>
      {(title || description || actions) && (
        <div className="flex items-center justify-between gap-4">
          <div>
            {title && <h2 style={{ fontFamily: "var(--afds-font-serif)", fontSize: "var(--fs-h2, 28px)", fontWeight: 600, letterSpacing: "var(--afds-track-title, -0.02em)", lineHeight: 1.1 }}>{title}</h2>}
            {description && <p className="text-muted-foreground">{description}</p>}
          </div>
          {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
        </div>
      )}
      <div className="space-y-8 flex flex-col flex-1 min-h-0">{children}</div>
    </div>
  )
}
